import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Box, Typography } from "@mui/material";
import { AvatarUser } from 'components/common';
import SelectVMP from "components/common/SelectVMP";
import { RolesPariticpant } from "constants/common";
import { t } from "i18next";
import { ROLE, RenderEmailOrNameUserDisplay } from "pages/subtitles/components/constants";

export default function UserRoom({dataParticipant, setChangeDataParticipant, index, OperatorRole, displayCloseIcon = true, isChangePeriod}){
    const handleChangeDataParticipant = (value, isDeleted = false) => {
        setChangeDataParticipant({
            ...dataParticipant,
            isDeleted: isDeleted,
            role: value,
        })
    }

    const convertRoleOwnerAndHostAndCoHostToString = (role) => {
        if(role === ROLE.HOST){
            return t('modalDetail.roleUser.host')
        } else if(role === ROLE.OWNER){
            return t('modalDetail.roleUser.owner')
        } else {
            return t('modalDetail.roleUser.coHost')
        }
    }

    const hasOperatorRole = () => {
        return dataParticipant?.role === ROLE.OWNER || dataParticipant?.participantType === ROLE.OWNER || dataParticipant?.role === ROLE.HOST || dataParticipant?.participantType === ROLE.HOST || dataParticipant?.role === ROLE.CO_HOST || dataParticipant?.participantType === ROLE.CO_HOST
    }

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', position: 'relative', padding: '10px 0 0 12px'}}>
                <AvatarUser user={dataParticipant} hasWrapper={true}/>
                <Box 
                    sx={OperatorRole ? 
                    {
                        borderLeftColor: 'transparent !important', 
                        border: theme => `1px solid ${theme.palette.ui.border}`, 
                        padding: '0 36px 0 8px',
                        borderRadius: '0 30px 30px 0', minHeight: '48px',
                        maxWidth: '222x',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'start'
                    } 
                    : 
                    {
                        borderLeftColor: 'transparent !important', 
                        border: theme => `1px solid ${theme.palette.ui.border}`, padding: '0 36px 0 8px', 
                        borderRadius: '0 30px 30px 0', 
                        minHeight: '48px', 
                        display: 'flex', 
                        flexDirection: (hasOperatorRole()) ? 'column' : 'row',
                        alignItems: (hasOperatorRole()) ? 'start' : 'center'
                    }
                    }
                >
                    <Box>
                        <RenderEmailOrNameUserDisplay name={dataParticipant?.name || ""} email={dataParticipant?.email}/>
                    </Box>
                    {   
                        hasOperatorRole() &&
                        (
                            (!isChangePeriod && dataParticipant?.role !== ROLE.OWNER)
                            ?
                            (
                                <SelectVMP role={dataParticipant?.role} data={RolesPariticpant} selectedValue={dataParticipant?.role} setSelectedValue={handleChangeDataParticipant} index={index} styleSelectElement={{fontSize: '12px', maxHeight: '12px'}} styleIconElement={{maxHeight: '18px'}}/>
                            )
                            :
                            (
                                <Typography sx={{fontSize:'12px', color: '#949595', padding: '1.5px 0'}}>{convertRoleOwnerAndHostAndCoHostToString(dataParticipant?.role || dataParticipant?.participantType)}</Typography>
                            )
                        )
                    }
                </Box>
                {
                    (displayCloseIcon && !isChangePeriod && dataParticipant?.role !== ROLE.OWNER) &&
                    <CloseRoundedIcon sx={{position: 'absolute', right: '4px', maxHeight: '14px', cursor: 'pointer', color:'#CB002B'}} onClick={() => handleChangeDataParticipant('', true)}/>
                }
                </Box>
        </>
    )
}
